import LazyLoad from "vanilla-lazyload";
import { CountUp } from 'countup.js';
import {
    initObserver, IPageObserverEntry
} from '../../Utilities/Helper.client';

import {TopMenuClient} from '../../Containers/TopNav/TopMenu.client';
import { showCurrentYear } from '../../Containers/SiteFooter/SiteFooter.client';
import webFontLoader from '../../Utilities/Webfontloader';
import {
    getSearchFormContainer,
    getSearchFormObservableEntry
} from '../../Components/SearchForm/SearchFormWidget.client';
import { StickyButtonPriceCompareClient } from '../../Components/StickyButtonPriceCompare/StickyButtonPriceCompare.client';
import {delayThirdPartyScripts} from '../../Utilities/DelayThirdPartyScripts';
import {toggleTopNavLogo, toggleTopNavStyling, topNavObserver} from '../../Containers/TopNav/TopNav.client';
import {aboveTheFoldObserver} from '../../Utilities/AboveTheFoldObserver.client';
import PolyfillLoader from '../../Utilities/PolyfillLoader';

const counterObserver = (): IPageObserverEntry | null => {
    const target: HTMLElement | null = document.querySelector('#customerCounter');

    if (target === null) {
        return target;
    }

    let animated: boolean = false;

    return {
        element: target,
        callback: (entry: IntersectionObserverEntry): void => {
            if (animated !== true && entry.intersectionRatio > 0) {
                animated = true;
                const countup = new CountUp('customerCounter', 662);
                countup.start();
            }
        }
    }
}

PolyfillLoader();

document.addEventListener('DOMContentLoaded', () => {
    webFontLoader();

    new LazyLoad({
        elements_selector: '.lazyload'
    });

    TopMenuClient();
    showCurrentYear();

    const searchFormContainer: HTMLElement | null = getSearchFormContainer();
    if (searchFormContainer !== null) {
        StickyButtonPriceCompareClient(searchFormContainer);
    }

    initObserver([
        getSearchFormObservableEntry(),
        counterObserver(),
        aboveTheFoldObserver(),
        topNavObserver(() => {
            toggleTopNavStyling(true);
            toggleTopNavLogo();
        })
    ]);
});

window.onload = () => {
    delayThirdPartyScripts();
}
